// src/components/layout/Layout.js

import React from 'react'
import Navigation from '../sidebar/Navigation'
import { Outlet } from 'react-router-dom'

export default function Layout (props) {
  // You can pass your Redux props down via context/provider if needed
  return (
    <div className='flex min-h-screen bg-gray-50'>
      <Navigation
        authActions={props.authActions}
        authState={props.authState}
        dashboardState={props.dashboardState}
      />
      <main className='flex-1 flex flex-col w-full px-4 sm:px-8 py-10 outlet-wrapper'>
        <Outlet />
      </main>
    </div>
  )
}
